/**
 * Dónde NO puede aparecer nada flotante de la app (el widget de feedback, las guías in-app).
 *
 * Vivía adentro de `FeedbackWidgetEntry`; se sacó cuando las guías necesitaron la misma regla, para
 * que las dos superficies no terminen con listas distintas.
 *
 * El portal y el CRM ya quedan afuera por el tipo de usuario; esto cubre las pantallas sin marco
 * (login, signup, reportes públicos) y el preview del portal, donde cualquier cosa flotante
 * aparecería adentro de la vista previa que el admin le está mostrando a su cliente.
 *
 * ⚠️ El chat de soporte (`SupportChatEntry`) NO respeta esta lista, a propósito: en
 * `/free-trial-ended` es la salida de «Extender el período de prueba» (UD-3 de /ux). Si el chat no
 * se monta ahí y su servicio sigue habilitado, ese botón vuelve a no hacer nada. Lo fija
 * `support_chat/__tests__/SupportChatEntry.test.js`.
 */
const SUPPRESSED_PREFIXES = [
    '/portal', '/crm', '/r/', '/login', '/signup', '/accept-invitation',
    '/auth/from-mcp', '/free-trial-ended', '/subscription-ended',
];
const PREVIEW_PATH_RE = /\/client\/\d+\/preview/;

export function isSuppressedPath(pathname) {
    if (!pathname) return false;
    if (PREVIEW_PATH_RE.test(pathname)) return true;
    return SUPPRESSED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

/** El preview del portal corre embebido: nada flotante puede aparecer adentro del iframe. */
export function isEmbedded() {
    try {
        return window.self !== window.top;
    } catch (_) {
        // Un SecurityError al leer `window.top` significa que estamos en un iframe cross-origin.
        return true;
    }
}
